declare global {
  // tslint:disable-next-line:variable-name
  let __maintenanceBypassEnabled;
}
export function IsMaintenanceBypassEnabled() { return __maintenanceBypassEnabled; }
